import { ActionsButton } from '../BorrowerComponents';

export const onActionsCellRender = (e, parentId) => {
    if (!parentId) {
        return null;
    } else {
        return (
            <ActionsButton
                data={e.data}
                parentId={parentId}
            />
        );
    }
};
